const normalizeStep = (step, fallbackRevision = 0) => {
  if (!step || typeof step.id !== "string" || !Number.isFinite(Number(step.order))) {
    return null;
  }
  return {
    id: step.id,
    order: Number(step.order),
    state: step.state === "completed" ? "completed" : "active",
    title: typeof step.title === "string" ? step.title : "",
    content: typeof step.content === "string" ? step.content : "",
    revision: Number(step.revision ?? fallbackRevision) || 0,
  };
};

const completeStep = (step) => ({
  ...step,
  state: "completed",
  title: step.title.endsWith(" 중")
    ? `${step.title.slice(0, -2)} 완료`
    : step.title,
});

export const mergeProgressStep = (steps, incoming, fallbackRevision = 0) => {
  const next = normalizeStep(incoming, fallbackRevision);
  if (!next) return steps;

  const existing = steps.find((step) => step.id === next.id);
  if (existing && existing.revision > next.revision) return steps;

  const hasLaterStep = steps.some((step) => step.order > next.order);
  if (hasLaterStep && next.state === "active") Object.assign(next, completeStep(next));
  if (existing?.state === "completed" && next.state === "active") {
    Object.assign(next, completeStep(next));
  }

  return [
    ...steps
      .filter((step) => step.id !== next.id)
      .map((step) => (
        step.order < next.order ? completeStep(step) : step
      )),
    next,
  ].sort((a, b) => a.order - b.order);
};

export const normalizeProgressSteps = (steps = [], fallbackRevision = 0) => (
  steps.reduce(
    (result, step) => mergeProgressStep(result, step, fallbackRevision),
    [],
  )
);
